import React, { useEffect } from "react";
import Sidebars from "../../../Components/sidebar";
import {
  useTheme,
  ThemeProvider,
  Typography,
  useMediaQuery,
  Box,
  Container,
  Paper,
} from "@mui/material";
import "../../css/Dashboard.css";
import PersonIcon from "@mui/icons-material/Person";
import { LineChart } from "@mui/x-charts/LineChart";
import MessageIcon from "@mui/icons-material/Message";
import Colorapps from "../../../configcss/color";
import FoodpopupAdmin from "../PopupsAd/Foodpopup";

const Dashboard = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Adjust breakpoint as needed

  useEffect(() => {
    localStorage.setItem("paid", 1);
  }, []);

  // Chart Related

  const valueFormatter = (value) => `${value}mm`;

  // const handlepopups = (popups) => {
  //   switch (popups)  {
  //     case 'food':
  //       return <FoodpopupAdmin />;
  //     // Add more cases for other popups as needed
  //     default:
  //       return null; // Return null or handle default case as needed
  //   }
  // }

  return (
    <>
      <ThemeProvider theme={theme}>
        <div style={{ display: "flex" }}>
          <Sidebars />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "20px",
            }}
          >
            <Typography>
              <span
                className={`headertext ${isSmallScreen ? "small-screen" : ""}`}
              >
                Dashboard
              </span>
            </Typography>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                marginTop: "20px",
              }}
            >
              <Box
                className={`adminboxveiw`}
                sx={{
                  width: "300px",
                  height: "120px",
                  backgroundColor: "white",
                  color: "#939596",
                  textAlign: "center",
                  borderRadius: "20px",
                }}
              >
                <FoodpopupAdmin />
              </Box>
              <Box
                className={`adminboxveiw`}
                sx={{
                  width: "300px",
                  height: "120px",
                  backgroundColor: "white",
                  color: "#939596",
                  textAlign: "center",
                  borderRadius: "20px",
                }}
              >
                <Container>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: "12px",
                      color: "#A098AE",
                      fontFamily: "sans-serif",
                      fontSize: "18px",
                      fontWeight: "400",
                    }}
                  >
                    <b>Disaster Relief</b>
                  </Typography>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: "7px",
                      color: "black",
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    988
                  </Typography>
                  <Typography style={{ fontSize: "10px", textAlign: "center" }}>
                    +10% than last month
                  </Typography>
                  <div className="sidebar-container">
                    <PersonIcon />
                  </div>
                </Container>
              </Box>
              <Box
                className={`adminboxveiw`}
                sx={{
                  width: "300px",
                  height: "120px",
                  backgroundColor: "white",
                  color: "#939596",
                  textAlign: "center",
                  borderRadius: "20px",
                }}
              >
                <Container>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: "12px",
                      color: "#A098AE",
                      fontFamily: "sans-serif",
                      fontSize: "18px",
                      fontWeight: "400",
                    }}
                  >
                    <b>Free Medicines</b>
                  </Typography>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: "7px",
                      color: "black",
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    988
                  </Typography>
                  <Typography style={{ fontSize: "10px", textAlign: "center" }}>
                    +10% than last month
                  </Typography>
                  <div className="sidebar-container">
                    <PersonIcon />
                  </div>
                </Container>
              </Box>
              <Box
                className={`adminboxveiw`}
                sx={{
                  width: "300px",
                  height: "120px",
                  backgroundColor: "white",
                  color: "#939596",
                  textAlign: "center",
                  borderRadius: "20px",
                }}
              >
                <Container>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: "12px",
                      color: "#A098AE",
                      fontFamily: "sans-serif",
                      fontSize: "18px",
                      fontWeight: "400",
                    }}
                  >
                    <b>Health Infrastructure</b>
                  </Typography>
                  <Typography
                    variant="h5"
                    style={{
                      marginTop: "7px",
                      color: "black",
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    988
                  </Typography>
                  <Typography style={{ fontSize: "10px", textAlign: "center" }}>
                    +10% than last month
                  </Typography>
                  <div className="sidebar-container">
                    <PersonIcon />
                  </div>
                </Container>
              </Box>
            </div>
            {/* FOOD PROGRAM CHART */}
            <Typography>
              <span
                className={`headertext ${isSmallScreen ? "small-screen" : ""}`}
              >
                Charts
              </span>
            </Typography>

            <Container style={{ flexGrow: 1 }}>
              <div style={{ justifyContent: "space-around" }}>
                <span className={`h5 ${isSmallScreen ? "small-screen" : ""}`}>
                  {" "}
                  <b>Show the Growth</b>
                </span>
                <div style={{ display: "flex", flex: 1 }}>
                  {" "}
                  {/* Empty div to push the chart to the right */}
                  <div>
                    <LineChart
                      xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
                      series={[
                        {
                          data: [2, 5.5, 2, 8.5, 1.5, 5],
                          area: true,
                        },
                      ]}
                      width={500}
                      height={300}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: "grey",
                      marginLeft: "90px",
                      marginTop: "-150px",
                    }}
                  >
                    <Container fixed sx={{ display: "flex", width: "100%" }}>
                      <Paper
                        elevation={3} // Add elevation for shadow effect
                        sx={{
                          flexGrow: 1, // Take up remaining space
                          padding: "20px", // Add padding for content spacing
                          margin: "10px", // Add margin for separation
                          textAlign: "center", // Center align content
                          backgroundColor: "#ffffff", // Background color
                          borderRadius: "10px", // Rounded corners
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Box shadow
                        }}
                      >
                        {/* Content inside the chart box */}
                        <div>
                          <MessageIcon
                            sx={{
                              color: Colorapps.themesecondary,
                              width: "100px",
                            }}
                          />
                        </div>
                        <span
                          className={`h5 ${
                            isSmallScreen ? "small-screen" : ""
                          }`}
                        >
                          <b>Current Messages</b>
                        </span>
                        <p style={{ fontSize: "10px", textAlign: "center" }}>
                          Peoples Contacting with you
                        </p>
                        <hr />
                        <div
                          style={{ height: "300px", marginTop: "20px" }}
                        ></div>
                      </Paper>
                    </Container>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </ThemeProvider>
    </>
  );
};

export default Dashboard;
